import { classNames } from 'utilities/Utils';
import { ChevronLeft, ChevronRight } from 'assets/common';

export enum ARROW_TYPE {
  left = 'left',
  right = 'right',
}

export const CarouselArrows = ({
  arrowType,
  disabled,
}: {
  arrowType: ARROW_TYPE;
  disabled: boolean;
}) => {
  const ArrowSvg = arrowType === ARROW_TYPE.left ? ChevronLeft : ChevronRight;
  return (
    <div
      className={classNames(
        'bg-color-white/40 h-18 w-8  flex items-center justify-center',
        arrowType === ARROW_TYPE.left ? 'rounded-r' : 'rounded-l',
      )}
    >
      <ArrowSvg
        className={
          disabled ? '[&>path]:fill-[#a6a6a6]' : '[&>path]:fill-text-primary'
        }
      />
    </div>
  );
};
